var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBug(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_299_2967)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#3182CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 4.875H7.94625C7.7775 4.5825 7.545 4.33125 7.26375 4.14L7.875 3.52875L7.34625 3L6.5325 3.81375C6.36 3.7725 6.18375 3.75 6 3.75C5.81625 3.75 5.64 3.7725 5.47125 3.81375L4.65375 3L4.125 3.52875L4.7325 4.14C4.455 4.33125 4.2225 4.5825 4.05375 4.875H3V5.625H3.78375C3.765 5.74875 3.75 5.8725 3.75 6V6.375H3V7.125H3.75V7.5C3.75 7.6275 3.765 7.75125 3.78375 7.875H3V8.625H4.05375C4.44375 9.29625 5.1675 9.75 6 9.75C6.8325 9.75 7.55625 9.29625 7.94625 8.625H9V7.875H8.21625C8.235 7.75125 8.25 7.6275 8.25 7.5V7.125H9V6.375H8.25V6C8.25 5.8725 8.235 5.74875 8.21625 5.625H9V4.875ZM7.5 6.375V7.5C7.5 7.5825 7.48875 7.67625 7.47375 7.7625L7.43625 8.00625L7.2975 8.25C7.0275 8.715 6.5325 9 6 9C5.4675 9 4.9725 8.71125 4.7025 8.25L4.56375 8.01L4.52625 7.76625C4.51125 7.68 4.5 7.58625 4.5 7.5V6C4.5 5.91375 4.51125 5.82 4.52625 5.7375L4.56375 5.49375L4.7025 5.25C4.815 5.055 4.9725 4.88625 5.15625 4.75875L5.37 4.6125L5.6475 4.545C5.76375 4.515 5.88375 4.5 6 4.5C6.12 4.5 6.23625 4.515 6.35625 4.545L6.61125 4.605L6.84 4.7625C7.0275 4.89 7.18125 5.055 7.29375 5.25375L7.43625 5.4975L7.47375 5.74125C7.48875 5.82375 7.5 5.9175 7.5 6V6.375ZM5.25 7.125H6.75V7.875H5.25V7.125ZM5.25 5.625H6.75V6.375H5.25V5.625Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_299_2967"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 12,
    height: 12,
    rx: 2,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBug);
export default __webpack_public_path__ + "static/media/bug.0dbc54aacb43d16ff2409a6537f49cf0.svg";
export { ForwardRef as ReactComponent };